module.exports = __webpack_public_path__ + "media/images/icons/twotone/gift-5070662016c10acd05f15c1462cab281.svg";